import * as React from 'react';
import { Flex, Box } from 'grid-styled';
import { pure } from 'recompose';

/* UI */
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

/* Components */
import LazyImage from '../../LazyImage/LazyImage';

/* Style */
import {
  bodyStyle,
  dialogStyle,
  customContentStyle,
  customContentStyleMobile,
} from '../../../../styles/global.style';
import hopeTheme from '../../../../styles/themes/hopeTheme';
import './NewsLetterConfirmationDialog.scss';

/* Data */
import { confirmThankYou, confirmTagLine, icon } from './NewsLetterData';

/* Utils */
import { mobile } from '../../../../utils/deviceWidths';

interface NewsLetterConfirmationDialogProps {
  containerWidth: number;
  isDialogOpen: boolean;
  closeDialog: () => void;
}

class NewsLetterConfirmationDialog extends React.Component<
  NewsLetterConfirmationDialogProps,
  {}
> {
  onClose = () => {
    this.props.closeDialog();
  };

  render() {
    const { isDialogOpen, containerWidth } = this.props;
    const isMobile = containerWidth <= mobile;

    let modifiedContentStyle = isMobile
      ? customContentStyleMobile
      : customContentStyle;
    modifiedContentStyle = {
      ...modifiedContentStyle,
      maxWidth: '408px',
    };

    const modifiedBodyStyle = { ...bodyStyle, minHeight: '284px', padding: 0 };

    return (
      <Dialog
        modal={false}
        open={isDialogOpen}
        autoScrollBodyContent
        className="dialog-root"
        bodyClassName="dialog-body newsletter-confirmation"
        autoDetectWindowHeight={false}
        repositionOnUpdate={false}
        title={
          <Flex align="center" justify="flex-end">
            <Box>
              <IconButton onClick={this.onClose}>
                <CloseIcon color={hopeTheme.toolBar.toolBarGreyText} />
              </IconButton>
            </Box>
          </Flex>
        }
        titleStyle={{
          padding: '0',
          backgroundColor: 'transparent',
        }}
        contentStyle={modifiedContentStyle as React.CSSProperties}
        bodyStyle={modifiedBodyStyle as React.CSSProperties}
        style={dialogStyle as React.CSSProperties}
      >
        <div className="newsletter-dialog-thanks">{confirmThankYou}</div>
        <div className="newsletter-email-icon">
          <LazyImage imgSrc={icon} imgHeight={125} imgWidth={125} />
        </div>
        <div className="newsletter-dialog-tagline">{confirmTagLine}</div>
      </Dialog>
    );
  }
}

export default pure(NewsLetterConfirmationDialog);
